/**
 * Decide si una entrada del nav está "activa" comparando contra el
 * pathname actual. `/dashboard` exige match exacto (es root de su
 * propia sección); el resto usa prefijo para que sub-rutas también
 * marquen el ítem padre (`/admin/areas` ilumina "Áreas" en el sidebar).
 */
export function isNavActive(
  pathname: string | null,
  href: string
): boolean {
  if (!pathname) return false;
  if (href === "/dashboard") return pathname === href;
  return pathname.startsWith(href);
}
